import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const LessonDiffDirective = angularDirectiveToReact('lessonDiff', {
    versionId1: '<',
    versionId2: '<',
    lessonId: '<',
});

export function LessonDiffComponent() {
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{
        lessonId: string;
        versionId1: string;
        versionId2: string;
    }>();

    return <LessonDiffDirective key={key} {...params} />;
}
